import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const checkInOnlineSlice = createSlice({
  name: "checkInOnline",
  initialState,
  reducers: {
    checkInOnlineStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    checkInOnlineSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    checkInOnlineFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetGetTimeCheckInOnline: (state) => {
      state.status = ReduxStateType.INIT;
    },
  },
});

export const {
  checkInOnlineStart,
  checkInOnlineSuccess,
  checkInOnlineFailed,
  resetGetTimeCheckInOnline,
} = checkInOnlineSlice.actions;

export default checkInOnlineSlice.reducer;
